import axiosHttpClient from "./axiosHttpClient";

export function post(data: any) {
	return axiosHttpClient.post('/plant', data);
}

export function remove(id: number) {
	return axiosHttpClient.get('/plant/delete/'+id.toString());
}

export function getAll() {
	return axiosHttpClient.get('/plants');
}

export function getOne(id: number) {
	return axiosHttpClient.get('/plant/one/'+id.toString());
}

export function deleteAllowed(id: number) {
	return axiosHttpClient.get('/plant/delete-allowed/'+id.toString());
}


